/**
 * Ruta para retomar una separación en el flujo del asesor (fix-50 · F-01). La usan el detalle de la
 * consulta tras «Corregir plan de pagos» y el aviso de una separación en corrección (feat-42).
 */
export function rutaEditarSeparacion(separacionId: string): string {
  return `/separations/${encodeURIComponent(separacionId)}/editar`;
}
